import cuid from 'cuid';

/**
 * Represents a unique identifier for some client.
 *
 * This is just some tag we can use to route messages to a specific user.
 */
export type ID = string & { readonly __tag: unique symbol };

/**
 * Create a new unique identifier.
 */
export function newID(): ID {
  return cuid() as ID;
}
